import { PaymentProcessResponse } from '../api/paymentService/types';

export const handlePayment = (response: PaymentProcessResponse) => {
    let form: HTMLFormElement;

    switch (response.type) {
        case 'redirect':
            window.location.href = response.url;
            break;
        case 'form':
            form = document.createElement('form');
            form.method = 'POST';
            form.action = response.url;

            Object.entries(response.fields || {}).forEach(([key, value]) => {
                const input = document.createElement('input');
                input.type = 'hidden';
                input.name = key;
                input.value = value;
                form.appendChild(input);
            });

            document.body.appendChild(form);
            form.submit();
            break;
        default:
            throw new Error(`Unsupported transaction type: ${response.type}`);
    }
};
